import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconChat = createIcon({
  displayName: 'IconChat',
  path: [
    <path
      key="0"
      d="M12 22.41L8.59 19H3V3H21V5H5V17H9.41L12 19.59L14.59 17H19V7H21V19H15.41L12 22.41Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
